<template>
  <div class="term-bank-detail">
    <div class="header">
      <button class="create primary"
              @click="handleUpload">{{$t('newProjectV2.uploadTerm')}}</button>
      <div class="header-right">
        {{$t('newProjectV2.mounted')}}<span class="num">{{mountNum}}</span>
        <button @click="handleMount" class="mount primary">{{$t('newProjectV2.mount')}}</button>
        <button @click="handleCancelAll" class="create">{{$t('newProjectV2.cancelAll')}}</button>
      </div>
    </div>
    <div class="term-content">
      <el-table border height="100%" ref="multipleTable" :data="termList" tooltip-effect="dark"
                @selection-change="handleSelectionChange" header-row-class-name="customHeader">
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.termBankName')" align="center" prop="name"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column :label="$t('newProjectV2.domain')" align="center">
          <template slot-scope="{ row }">
            {{ $i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.sentNum')" align="center" prop="sentCount"
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.mount')" align="center" prop="isEnable">
          <template slot-scope="{ row }">
            <el-switch v-model="row.isEnable" active-color="#0078FC" inactive-color="#DCDCDC">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="term-bottom">
      <el-checkbox v-model="termIntervene" @change="changeTerm">{{$t('newProjectV2.termIntervene')}}
      </el-checkbox>
    </div>
    <!-- 新版上传弹窗 -->
    <UploadCorpus bankType="term" title="upload" uploadType="project" :dialogVisible="uploadVisible"
                  :corpusDetailInfo="createInfo" @handleClose="handleUploadCancel"
                  @handleConfirm="updateMemoryBank" :accept="accept" />
  </div>
</template>

<script>
import UploadCorpus from '@/views/corpus/components/corpusDetailUploadDialog';

export default {
  name: 'TermBankDetail',
  props: {
    termList: {
      type: Array,
      default() {
        return [];
      }
    },
    isTermIntervene: {
      type: Boolean,
      default() {
        return false;
      }
    },
    createInfo: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  components: {
    UploadCorpus
  },
  data() {
    return {
      termIntervene: this.isTermIntervene,
      uploadVisible: false,
      accept: '.xlsx, .txt, .tbx, .zip',
    }
  },
  methods: {
    handleUpload() {
      this.uploadVisible = true;
    },
    handleUploadCancel() {
      this.uploadVisible = false;
    },
    // 挂载
    handleMount() {
      if (this.termSelection.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selTermBankTip'));
      }
      this.termSelection.forEach(item => {
        this.termList.forEach(i => {
          if (i.id === item.id) {
            i.isEnable = true;
          }
        });
      });
      // 取消选中
      this.$refs.multipleTable.clearSelection();
    },
    updateMemoryBank() {
      this.$emit('updateMemoryBank', 'term');
      this.$message.success(this.$t('newProjectV2.uploadSuccess'));
      this.uploadVisible = false;
    },
    handleCancelAll() {
      this.termList.forEach(item => {
        item.isEnable = false;
      });
    },
    // checkbox的change事件
    handleSelectionChange(selection) {
      this.termSelection = selection;
    },
    changeTerm(newVal) {
      this.$emit('changeTerm', newVal);
    }
  },
  computed: {
    mountNum() {
      return this.termList.filter(item => item.isEnable === true).length;
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>